import { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any; // for spread props
}

export const Container = ({ children, className = '', ...restProps }: ContainerProps): JSX.Element => (
  <div
    className={`flex flex-col items-center w-full max-w-[864px] ${className}`}
      // eslint-disable-next-line react/jsx-props-no-spreading
    {...restProps}
  >
    {children}
  </div>
  );
